import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsGQ: CultureInfo = {
  name: 'es-GQ',
  displayName: 'español (Guinea Ecuatorial)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-GQ',
  parent: CultureInfoEs
};
